import { plainTextLength } from '@/lib/notificationHtml'

const SAFE_LINK_PREFIXES = ['https://', 'http://', 'mailto:']

/** Links the server sanitizer keeps — anything else would be stripped on send. */
export function isSafeLinkHref(href: string): boolean {
  const lower = href.trim().toLowerCase()
  return SAFE_LINK_PREFIXES.some((prefix) => lower.startsWith(prefix) && lower.length > prefix.length)
}

/** Plain-text length used for the counter (markup excluded, matches campaign-service). */
export function richTextPlainLength(html: string): number {
  return plainTextLength(html)
}
